import {Box, Button, makeStyles} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import MenuOpenIcon from '@material-ui/icons/MenuOpen'
import * as React from 'react'
import {SSMPalette} from './AppTheme'
import { LNG } from '../Services/LanguageService';

const useStyles = makeStyles((theme) => ({
    headline: {
        display: 'flex',
        alignItems: 'stretch',
        padding: theme.spacing(0, 3),
        textTransform: 'uppercase',
        background: SSMPalette.gray.alabaster,
        position: 'relative',
        zIndex: 5,
        height: 54,
        color: theme.palette.text.primary,
    },
    title: {
        margin: 'auto 0',
    },
    button: {
        background: SSMPalette.gray.linen,
        color: SSMPalette.gray.graphite,
        borderRadius: 0,
        position: 'relative',
        width: 50,
        margin: theme.spacing(0, 1, 0, -3),
        padding: theme.spacing(0, 1.25, 0, 0),
        '&::before': {
            content: '\'\'',
            display: 'block',
            border: 'solid 10px transparent',
            borderRight: 0,
            borderTop: 'solid 25px ' + SSMPalette.gray.alabaster,
            height: '50%',
            position: 'absolute',
            right: 0,
            zIndex: 50,
            top: 0,
        },
        '&::after': {
            content: '\'\'',
            display: 'block',
            border: 'solid 10px transparent',
            borderRight: 0,
            borderBottom: 'solid 25px ' + SSMPalette.gray.alabaster,
            height: '50%',
            position: 'absolute',
            right: 0,
            zIndex: 50,
            bottom: 0,
        },
    },
}))
type HeadLineProps = {
    open: boolean;
    onClick: () => void;
}
export const HeadLine = (props: HeadLineProps) => {
    const classes = useStyles()
    return (
        <Box className={classes.headline} boxShadow={4}>
            <Button className={classes.button} onClick={props.onClick}>
                {props.open ? <MenuOpenIcon/> : <MenuIcon/>}
            </Button>
            <div className={classes.title}>
                {LNG.Text('Dashboard.27')}
            </div>
        </Box>
    )
}